import { MasterDataEntity, MasterDataUnit } from 'src/types'
import { GetMasterDataQuery } from 'src/types/generated'

export const MasterDataTranslator = {
  toEntity: (query: GetMasterDataQuery): MasterDataEntity => {
    return {
      worksRoles: query.masterData?.worksRoles?.every(d => !!d)
        ? (query.masterData?.worksRoles as MasterDataUnit[])
        : [],
      companyPolicies: query.masterData?.companyPolicies?.every(d => !!d)
        ? (query.masterData?.companyPolicies as MasterDataUnit[])
        : [],
    }
  },
} as const
